"use client";

import React from "react";

import { Skeleton } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import { PRODUCT_CARD_CLASSES } from "~/components/product-card/constants";
import { ProductCardContainer } from "~/components/product-card/styled";

import { PRODUCTS_FILTERS_CLASSES } from "../products-layout/components/products-filters/constants";
import { ProductsFiltersContainer } from "../products-layout/components/products-filters/styled";
import { ProductsTopBarContainer } from "../products-layout/components/products-top-bar/styled";
import { PRODUCTS_LAYOUT_CLASSES } from "../products-layout/constants";
import { ProductsLayoutContainer } from "../products-layout/styled";
import { PRODUCTS_LIST_CLASSES } from "../products-list/constants";
import { ProductsGridContainer } from "../products-list/styled";

import { SearchResultsPageContainer } from "./styled";

export const SrpSkeleton = () => {
  return (
    <SearchResultsPageContainer>
      <Skeleton height={40} width="55%" sx={{ mb: 7, mt: 5 }} animation={false} />
      <ProductsLayoutContainer
        isChips={false}
        isFiltersOpen={true}
        sx={{ height: "100%" }}
      >
        <ProductsFiltersContainer sx={{ display: { xs: "none", md: "block" } }}>
          <Box className={PRODUCTS_FILTERS_CLASSES.filterContentWrapper}>
            <Skeleton height="100%" width="100%" animation={false} />
          </Box>
        </ProductsFiltersContainer>
        <Box
          id="product-list"
          className={PRODUCTS_LAYOUT_CLASSES.productListWrapper}
        >
          <Box height={50}>
            <ProductsTopBarContainer
              className={PRODUCTS_LAYOUT_CLASSES.topBar}
              sx={{ alignItems: "baseline !important" }}
            >
              <Skeleton height="50%" width={120} animation={false} />
              <Skeleton height="50%" width={160} animation={false} />
            </ProductsTopBarContainer>
          </Box>
          <ProductsGridContainer>
            <Box className={PRODUCTS_LIST_CLASSES.productGrid}>
              <Grid container>
                {Array.from({ length: 12 }, (_, i) => `skeleton-${i}`).map((key) => (
                  <Grid item xs={6} sm={4} md={4} lg={4} xl={3} key={key}>
                    <ProductCardContainer isShoppingListLayout>
                      <Skeleton width="100%" height={300} animation={false} />
                      <Box className={PRODUCT_CARD_CLASSES.description}>
                        <Box sx={{ width: "70%" }}>
                          <Box className={PRODUCT_CARD_CLASSES.title}>
                            <Skeleton width={130} animation={false} />
                          </Box>
                          <Box className={PRODUCT_CARD_CLASSES.price}>
                            <Skeleton width={85} animation={false} />
                          </Box>
                          <Box className={PRODUCT_CARD_CLASSES.colors}>
                            <Skeleton width={60} animation={false} />
                          </Box>
                        </Box>
                        <Skeleton
                          height={24}
                          width={24}
                          sx={{ mt: 2, mr: 2, ml: "auto" }}
                          animation={false}
                        />
                      </Box>
                    </ProductCardContainer>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </ProductsGridContainer>
        </Box>
      </ProductsLayoutContainer>
    </SearchResultsPageContainer>
  );
};
